import React from 'react';
import SSOConfigurationAdd from './SSOConfigurationAdd'

const AddSSOConfiguration = () => {
    return (
        <SSOConfigurationAdd />
    )
}

export default AddSSOConfiguration
